import { AnnouncementSchema, type Announcement } from '../types';
import { a_2026_05_15 } from './2026-05-15-mise-a-jour-produit';
import { a_2026_06_10 } from './2026-06-10-analyse-avancee-dossier';
import { a_2026_06_21 } from './2026-06-21-nouvelle-interface-hector';
import { a_2026_07_03 } from './2026-07-03-memoire-hector';
import { a_2026_07_06 } from './2026-07-06-conclusions-replique';
import { a_2026_07_07 } from './2026-07-07-droit-administratif';
import { a_2026_07_15 } from './2026-07-15-organisation-pieces';
import { a_2026_07_20 } from './2026-07-20-numerotation-ia';
import { a_2026_09_28 } from './2026-09-28-canvas-redaction';
import { outlookAnnouncement } from './2026-10-12-hector-outlook';
import { a_2026_11_02 } from './2026-11-02-plusieurs-dossiers';

// Un fichier par annonce. Ajouter l'import ci-dessus + l'entrée ci-dessous.
// Validé au chargement : une erreur de structure casse vite et clairement.
const raw: Announcement[] = [a_2026_05_15, a_2026_06_10, a_2026_06_21, a_2026_07_03, a_2026_07_06, a_2026_07_07, a_2026_07_15, a_2026_07_20, a_2026_09_28, outlookAnnouncement, a_2026_11_02];

export const ANNOUNCEMENTS: Announcement[] = raw
  .map((a) => AnnouncementSchema.parse(a))
  .sort((x, y) => (x.date === y.date ? (x.id < y.id ? 1 : -1) : x.date < y.date ? 1 : -1));
